import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqbd9wvwp7: FaireProductEntity = {
  token: "p_gqbd9wvwp7",
  type: "product",
  name: "Handmade Snake Ring - A-505",
  brandToken: "b_pntx8vkece",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cd90618d8881e8133ee196cf0c823b1584f21843b687130aad76fcd2f54f2629.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf9e45370019d4533e20b7d5fe1d5eb77a31f598609da1bebe70b1ecaabecdd6.jpeg",
    "https://cdn.faire.com/fastly/c12d5531e0be1ead12433fdcadfe511a30124457cfb6d5ddc4b30de627dbd881.jpeg",
    "https://cdn.faire.com/fastly/0a5aaa2115d52f9412ac6fda886b23caf119c5e23b26b8f27396861c4aec1d48.jpeg",
    "https://cdn.faire.com/fastly/c613b9cb2ef886754f48cbc4aa16ee8f4575b0aaa0446b0a01d400f816c8f7ff.jpeg",
    "https://cdn.faire.com/fastly/f1baade81f0b54fe4d2e6b4b39e63f6bf3513738f949182756714463575f9c36.jpeg",
  ],
  priceDollars: 12.7,
  description:
    "made of steel\nsize (measure | inner diameter): \n6 > 16.5 mm\n7 > 17.3 mm\n8 > 18.1 mm\n9 > 19.0 mm\n10 > 19.8 mm\n11 > 20.6 mm\n12 > 21.4 mm\n13 > 22.2 mm\n",
  tags: [],
  msrpDollars: 25.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:44.544Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
